import { render, staticRenderFns } from "./replaceLink.vue?vue&type=template&id=3f007a20&scoped=true&"
import script from "./replaceLink.vue?vue&type=script&lang=js&"
export * from "./replaceLink.vue?vue&type=script&lang=js&"
import style0 from "./replaceLink.vue?vue&type=style&index=0&id=3f007a20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f007a20",
  null
  
)

export default component.exports